import React, { Component } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        return <Component {...props} router={{ location, navigate }} />;
    }
    return ComponentWithRouterProp;
}

class PageUnauthorized extends Component {
    render = () => {
        return (
            <div className="wow">
                <div className="boxu" style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '48px', marginBottom: '12px' }}>🚫</div>
                    <h2 className="signIn" style={{ marginBottom: '8px' }}>Access Denied</h2>
                    <p className="signInMessage" style={{ marginBottom: '24px' }}>
                        You don't have permission to access this page.
                    </p>
                    <button
                        className="logSubmit"
                        onClick={() => this.props.router.navigate('/')}
                    >
                        Go Home
                    </button>
                </div>
            </div>
        );
    }
}

export default withRouter(PageUnauthorized);
